import { render, staticRenderFns } from "./FrenteDeCaixaPendentes.vue?vue&type=template&id=3845bd7e&scoped=true&"
import script from "./FrenteDeCaixaPendentes.vue?vue&type=script&lang=js&"
export * from "./FrenteDeCaixaPendentes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3845bd7e",
  null
  
)

export default component.exports